import styled from '@emotion/styled';
import MuiButton from '@material-ui/core/Button';

export const ButtonBase = styled(MuiButton)`
  transition: none;
  padding: 0 1rem;
  font-size: 1rem;
  text-transform: none;
  white-space: nowrap;
  transition: all ease-in-out 0.2s;

  &,
  &.MuiButton-root.Mui-disabled {
    color: ${({ theme }) => theme.colors.textLight};
  }

  &.MuiButton-root.Mui-disabled {
    opacity: 0.65;
  }

  .MuiButton-label {
    font-family: ${({ theme }) => theme.fonts.default};
  }
`;
